import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface BreadcrumbRequest {
    breadcrumbs: Breadcrumb[];
}
export class Breadcrumb {
    constructor(public title: string, public url: string, public params?: { [p in string]: any }) {
    }
}

@Injectable({ providedIn: 'root' })
export class BreadcrumbsService {
    private subject = new Subject<BreadcrumbRequest>();

    sendBreadcrumbs(breadcrumbs: BreadcrumbRequest) {
        this.subject.next(breadcrumbs);
    }

    clearBreadcrumbs() {
        this.subject.next();
    }

    getBreadcrumbs(): Observable<BreadcrumbRequest> {
        return this.subject.asObservable();
    }


}